import React from 'react';

export default function InappRestore(props) {
  return (
    <>
      <div className="passGroup">
        <div className="passSectionTitleWrap_type2">
          <em className="passSectionTitle">{props.data.title}</em>
        </div>
        <div className="restoreBuyList">
          {props.lang === 'ko' ? <p className="restoreBuy-text">{props.data.sub_title}</p> : ''}
          <div className="restoreBuyBtns">
            {
              props.data.button.map((item, index) => {
                return (
                  <a
                    key={`pass-group-restore-button-${index}`}
                    className={`btnLineType_${item.color}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault(); // 페이지 이동 막기
                      if (item.type === 'subs') {
                        props.subsRestore();
                      } else {
                        props.inappRestore();
                      }
                    }}
                  >
                    {item.title}
                  </a>
                )
              })

            }
          </div>
        </div>
      </div>
    </>
  );
}
